/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var NetworkIcon = createIcon({
  name: 'NetworkIcon',
  height: 1024,
  width: 1170,
  svgPath: 'M1024 877.257h-877.714v-219.429h877.714v219.429zM949.257 731.428h-218.971v73.143h218.971v-73.143zM1080.457 276.114c-10.743 10.743-23.543 16-38.857 16h-54.857v146.057c0 19.886-7.314 36.8-21.714 51.429-14.4 14.4-31.543 21.714-51.429 21.714h-291.886v110.4h-73.143v-110.629h-292.343c-19.886 0-36.8-7.314-51.429-21.714-14.4-14.4-21.714-31.543-21.714-51.429v-146.057h-54.857c-15.314 0-28.114-5.257-38.857-16s-16-23.543-16-38.857v-182.629c0-15.314 5.257-28.114 16-38.857s23.543-16 38.857-16h182.629c15.314 0 28.114 5.257 38.857 16s16 23.543 16 38.857v182.629c0 15.314-5.257 28.114-16 38.857s-23.543 16-38.857 16h-54.857v146.057h292.571v-146.057h-54.857c-15.314 0-28.114-5.257-38.857-16s-16-23.543-16-38.857v-182.629c0-15.314 5.257-28.114 16-38.857s23.543-16 38.857-16h182.629c15.314 0 28.114 5.257 38.857 16s16 23.543 16 38.857v182.629c0 15.314-5.257 28.114-16 38.857s-23.543 16-38.857 16h-54.857v146.057h292.343v-146.057h-54.857c-15.314 0-28.114-5.257-38.857-16s-16-23.543-16-38.857v-182.629c0-15.314 5.257-28.114 16-38.857s23.543-16 38.857-16h182.629c15.314 0 28.114 5.257 38.857 16s16 23.543 16 38.857v182.629c0 15.314-5.257 28.343-16 39.086z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
});

export default NetworkIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/network-icon.js
// module id = 1157
// module chunks = 0